import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { connect, useDispatch } from 'react-redux';
import { dealerListingRequest, dealerListingUpdateUserStatus, dealerPhone, verifiedUserEmail } from '../../../redux/actionDispatcher/admin/dealerListingDispatcher';
import { ApiURLs } from '../../../constant/ApiUrls';
import Swal from 'sweetalert2';
import { patchData } from '../../../services/api';
import { NavigationRoutes } from '../../../constant/Routes';
import { useNavigate } from 'react-router-dom';
import moment from "moment";

import { CheckCircle, XCircle } from "lucide-react";
import AddDealer from './AddDealer';
// import AddTierPopup from './AddTierToDealer';

import { getTierListing } from '../../../features/tiers/redux/tierDispatcher';
import { getMakeListing } from '../../../features/make/redux/makeDispatcher';

function DealerLisitingTable({ dealerListing }) {


  const dispatch = useDispatch();
  const navigate = useNavigate();




  const [tiers, setTiers] = useState([]);
  const [allMakes, setAllMakes] = useState([]);


  // ✅ State for pagination
  const [page, setPage] = useState(0); // Starts from 0
  const [pageSize, setPageSize] = useState(50);
  const [sortModel, setSortModel] = useState([{ field: "created_at", sort: "desc" }]);
  const [searchTerm, setSearchTerm] = useState('');

  const [isReady, setIsReady] = React.useState(false);



  const handleVerifyEmail = (row) => {
    // console.log("Deleting User ID:", row);
    Swal.fire({
      // title: `${"Verify Phone Confirmation"}`,
      html:

        "Are you sure?" +
        "<br>" +
        `You want to verify email <b>${row.email}</b> of <b>${row.name}</b>`,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: `Yes, Verify`,
      showCloseButton: true,
      cancelButtonColor: "gray",
      confirmButtonColor: "#4f83df",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(verifiedUserEmail({ userId: row.id, email_verified: 1 }));
        var response = await patchData(`${ApiURLs.USER_UPDATE}/${row.id}`, { email_verified: 1 });
        if (response.status !== 1) {

          dispatch(verifiedUserEmail({ userId: row.id, email_verified: 1 }));
        }
      }
    });

    // Add your delete logic here
  };


  const dealerListingHeading = [

    {
      field: "created_at", headerName: "Join Date", width: 100,
      // renderCell: (params) => moment(params.value).format("DD/MM/YYYY HH:mm:ss"), 
      renderCell: (params) => {
        const formattedDate = moment(params.value).format("DD/MM/YYYY");
        const fullDateTime = moment(params.value).format("DD/MM/YYYY HH:mm:ss");
        return (
          <span title={fullDateTime}>
            {formattedDate}
          </span>
        );
      },

      // renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,

    },
    {

      field: "business_name", headerName: "Dealer Name", width: 130
    },
    {
      flex: 2,
      field: "email", headerName: "Email", width: 130,
      //  renderCell: (params) => (
      //   <span style={{ color: params.row.email_verified === 1 ? "green" : "red" }}>
      //     {params.value}
      //   </span>
      // ), 


      renderCell: (params) => {
        const isVerified = params.row.email_verified === 1;



        return (
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            {params.value.trim() !== "Not Added" &&
              (isVerified ? (
                <CheckCircle className="icon-fixed" color="green" size={18} />
              ) : (
                <XCircle className="icon-fixed" color="red" size={18} />
              ))
            }
            <span >{params.value}</span>

          </div>
        );
      },
    },


    // {
    //   field: "email_verified", headerName: "Email Status", width: 100,
    //   valueGetter: (value, row) => `${row.email_verified === 1 ? 'Verified' : 'Not Verified'}`,
    //   renderCell: (params) => (
    //     <span style={{ color: params.row.email_verified === 1 ? "green" : "red" }}>
    //       {params.value}
    //     </span>
    //   ),

    // },


    {

      field: "number",
      headerName: "Number",
      flex: 1,
      minWidth: 130,

      maxWidth: 180,
      sortable: false,
      valueGetter: (value, row) => `${row.flag || ''} ${row.number || 'Not Added'}`,
      // renderCell: (params) => (
      //   <span style={{ color: params.row.otp_verified === 1 ? "green" : "red" }}>

      //     {params.value==="Not Added"?params.value:`+${params.value}`}
      //   </span>
      // ),
      renderCell: (params) => {
        const isVerified = params.row.otp_verified === 1;

        const numberValue =
          params.value.trim() === "Not Added" ? params.value.trim() : `+${params.value}`;

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            {params.value.trim() !== "Not Added" &&
              (isVerified ? (
                <CheckCircle className="icon-fixed" color="green" size={18} />
              ) : (
                <XCircle className="icon-fixed" color="red" size={18} />
              ))
            }
            <span style={
              params.value.trim() === "Not Added" ? { color: "red" } : {}
            }>{numberValue}</span>

          </div>
        );
      },
    },


    // {

    //   field: "total_hours_logged",
    //   headerName: "LogIn\nHrs.",
    //   flex: 1,
    //   minWidth: 80,

    //   maxWidth: 80,
    //   sortable: true,
    //   valueGetter: (value, row) => `${row.total_hours_logged || '0'} hrs`,
    //   // renderCell: (params) => params.value




    // },

    {

      field: "ads_count",
      headerName: "Ads Live",
      flex: 1,
      minWidth: 50,

      maxWidth: 80,
      sortable: true,
      // valueGetter: (value, row) => `${'0'}`,
      // renderCell: (params) => params.value




    },
    {
      field: "action",
      headerName: "Action",
      width: 300,
      sortable: false,

      renderCell: (params, row) => (
        <div style={{
          display: "flex", flexDirection: "row", gap: "4px", alignItems: "center",
          height: "100%"
        }}>

          {(params.row.otp_verified === 0 && params.row.number !== '' && params.row.number !== undefined && params.row.number !== null) && (<button
            onClick={() => handleVerifyPhone(params.row)}
            style={{
              backgroundColor: "green",
              color: "white",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px",
              fontSize: "10px",
              width: "100%",
              height: "24px",  // Increased height
              padding: "2px 5px", // Added padding
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Verify Phone
          </button>)}


          <button
            onClick={() => {
              // console.log("veiw is called")
              navigate(NavigationRoutes.ADMIN_DASHBOARD + NavigationRoutes.USER_DETAILS.replace(":id", `:${params.row.id}`));
            }}
            style={{
              backgroundColor: "rgb(131 131 131)",
              color: "white",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px",
              fontSize: "10px",
              width: "100%",
              height: "24px",  // Increased height
              padding: "2px 5px", // Added padding
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            View
          </button>
          <AddDealer editMode={true} tierList={tiers} dealerData={params.row} allMake={allMakes} />

          {/* <AddTierPopup tierList={tiers} userData={params.row} ></AddTierPopup> */}

          <button
            onClick={() => handleBlock(params.row)}
            style={{
              backgroundColor: "#F44336",
              color: "white",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px",
              fontSize: "10px",
              width: "100%",
              height: "24px",  // Increased height
              padding: "2px 5px", // Added padding
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {params.row.status === 1 ? "Block" : "Unblock"}
          </button>




          {(params.row.email_verified === 0) && (<button
            onClick={() => handleVerifyEmail(params.row)}
            style={{
              backgroundColor: "green",
              color: "white",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px",
              fontSize: "10px",
              width: "100%",
              height: "24px",  // Increased height
              padding: "2px 5px", // Added padding
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Verify Email
          </button>)}




        </div>

      ),
    },
  ];

  const handleBlock = (row) => {
    console.log("Deleting User ID:", row);
    Swal.fire({
      title: `${row.status === 1 ? "Block" : "Unblock"}`,
      html:
        "<hr>" +
        "Are you sure?" +
        "<br>" +
        `You want to  ${row.status === 1 ? "block" : "unblock"
        } ${row.name}`,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: `${row.status === 1 ? "Block" : "Unblock"}`,
      showCloseButton: true,
      cancelButtonColor: "gray",
      confirmButtonColor: "#4f83df",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(dealerListingUpdateUserStatus({ userId: row.id, status: row.status === 1 ? 0 : 1 }));
        var response = await patchData(`${ApiURLs.GET_USERS}/${row.id}`);
        if (response.status !== 1) {

          dispatch(dealerListingUpdateUserStatus({ userId: row.id, status: row.status === 1 ? 0 : 1 }));
        }
      }
    });

    // Add your delete logic here
  };


  const hasFetched = React.useRef(false);


  const handleVerifyPhone = (row) => {
    // console.log("Deleting User ID:", row);
    Swal.fire({
      // title: `${"Verify Phone Confirmation"}`,
      html:

        "Are you sure?" +
        "<br>" +
        `You want to verify phone number  <b>+${row.flag} ${row.number}</b> of <b>${row.name}</b>`,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: `Yes, Verify`,
      showCloseButton: true,
      cancelButtonColor: "gray",
      confirmButtonColor: "#4f83df",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(dealerPhone({ userId: row.id, otp_verified: 1 }));
        var response = await patchData(`${ApiURLs.USER_UPDATE}/${row.id}`, { otp_verified: 1 });
        if (response.status !== 1) {

          dispatch(dealerPhone({ userId: row.id, otp_verified: 1 }));
        }
      }
    });

    // Add your delete logic here
  };

  React.useEffect(() => {
    if (hasFetched.current) return; // 🚫 already called

    hasFetched.current = true; // ✅ mark as called

    const fetchInitialData = async () => {
      try {
        const tiers = await dispatch(getTierListing());
        setTiers(tiers);

        const makes = await dispatch(getMakeListing());
        setAllMakes(makes.map(item => ({
          value: item.name,
          label: item.name
        })));

        console.log("Fetched Makes:", makes);

        setIsReady(true);
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };

    fetchInitialData();

  }, [dispatch]);


  React.useEffect(() => {
    if (!isReady) return; // 🚫 don't run before data is ready

    const sortField = sortModel[0]?.field || "created_at";
    const sortOrder = sortModel[0]?.sort || "desc";

    dispatch(
      dealerListingRequest(
        sortField,
        sortOrder,
        page + 1,
        pageSize,
        searchTerm
      )
    );

  }, [isReady, sortModel, page, pageSize, searchTerm, dispatch]);

  return (

    <Paper sx={{ height: "95%", width: '100%' }}>


      <div style={{
        padding: "10px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <input
          type="text"
          placeholder="Search by Name, Email, Number"
          value={searchTerm}
          onChange={(e) => {
            setPage(0);
            setSearchTerm(e.target.value);
          }}
          style={{
            padding: "6px 10px",
            fontSize: "14px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            width: "50%"
          }}
        />
        <AddDealer tierList={tiers} allMake={allMakes} />
      </div>

      <DataGrid
        rows={dealerListing.dealerListing || []}
        columns={dealerListingHeading || []}
        rowCount={dealerListing.totalDealers || 0} // ✅ Total count from Redux
        paginationMode="server" // ✅ Enable manual pagination
        sortingMode="server"
        page={page}
        pageSize={pageSize}
        sortModel={sortModel}
        onSortModelChange={(model) => setSortModel(model)}
        pageSizeOptions={[10, 25, 50]}
        loading={dealerListing.loading}
        checkboxSelection={false}
        sx={{ border: 0 }}
        paginationModel={{ page, pageSize }}
        onPaginationModelChange={(model) => {
          setPage(model.page);
          setPageSize(model.pageSize);
        }}
      />
    </Paper>
  );
}

//Getting the state from the store
const mapStateToProps = (state) => {
  return {
    dealerListing: state.dealerListing,
  };
};

//passing the userData in fetchUsers function and also dispatch method
const mapDispatchToProps = (dispatch) => {
  return {
    dealerLisiting: (data, navigate) => dispatch(dealerListingRequest(data, navigate)),
  };
};

//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(DealerLisitingTable);
